document.body.addEventListener("touchstart", function (e) {
  const target = e.target.closest(".has-secondary-image-swap");
  if (!target) return;

  // run only on mobile
  if (window.innerWidth <= 768) {
    const thumbnailImages = target.querySelectorAll(".product-image__wrapper img");
    const thumbnailVideo = target.querySelector(".product-image__wrapper .video-on-hover");

    thumbnailImages.forEach((img) => {
      img.classList.toggle("swap--visible");
    });

    if (thumbnailVideo) {
      thumbnailVideo.classList.toggle("swap--visible");
    }
  }
});